let _ = require('../_.js');
let $ = jQuery;

// -------------- DATA UPDATES ------------------
//
// Document me
//

// This stores an array of all functions which have subscribed to new/updated ac data.
let ac_data_callbacks = [];
// let ac_current_item_updated_callbacks = [];

_.AuctionUI_Data = class AuctionUI_Data {

    static async init() {
        try {
            _.ac_state.auction = await App_Models_Auction.get(_.AuctionUI.auction_id());
        } catch (e) {
            _.flash_error("There was an error loading auction data.  We are sorry for the inconvienence. Please rerfresh / reload the page.");
        }

        console.log("auction state variable loaded");

        for (let val of ac_data_callbacks) {
            let path = val.path;
            let callback = val.callback;
            _.ac_state.auction.subscribe(path, callback);
        }
        ac_data_callbacks = [];
    }

    /**
     * This function allows the registration of callbacks that get triggered 
     * whenever there is a change in the associated data path in 
     * The path parameter should be a string that represents the path to the 
     * data in the ac_data object (e.g., "field.subfield").
     * The callback should be a function that gets called with the new value of the data.
     */
    // _.AuctionUI_Data.on_data_update = function (path, callback) {
    static on_data_update(path, callback) {
        let pathParts = path.split('.');
        let currentPart = pathParts.shift();
        let newPath = pathParts.join(".");

        if (currentPart == 'auction') {
            if (!_.ac_state.auction) {
                ac_data_callbacks.push({ path: newPath, callback: callback });
            } else {
                _.ac_state.auction.subscribe(newPath, callback);
            }
        }
    }


    /**
     * Whole farm auctions: the whole farm lot (the item on the whole farm round). Its title names the whole
     * farm everywhere ("Entire Development") except the auction format name. Read from the ORM on every
     * call, so a realtime rename is used from the next call on. Null for other formats.
     */
    static async whole_farm_item() {
        if (!_.AuctionUI.auction_is_enterprise()) {
            return null;
        }
        let round = await _.ac_state.auction.whole_farm_round.fetch();
        return round ? await round.auction_item.fetch() : null;
    }

    static async whole_farm_title() {
        let item = await _.AuctionUI_Data.whole_farm_item();
        return item ? item.title : '';
    }

    // // Call _.on_ac_data_current_item_updated to register a listener for changed current item, since this is used so much
    // _.on_ac_data_current_item_updated = function (callback) {
    //     _._ac_current_item_updated_callbacks.push(callback);
    // }

}
